import { Component } from '@angular/core';
import { FeedbackPlatformSectionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Sections') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformsection-form',
    templateUrl: './feedbackplatformsection.form.component.html'
})
export class FeedbackPlatformSectionFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformSectionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'sessions', sectionName: 'Sessions', isExpanded: false },
            { sectionKey: 'presentations', sectionName: 'Presentations', isExpanded: false },
            { sectionKey: 'committeeMembers', sectionName: 'Committee Members', isExpanded: false },
            { sectionKey: 'committeeSelections', sectionName: 'Committee Selections', isExpanded: false }
        ]);
    }
}

